module.exports = __webpack_public_path__ + "static/vw_com_ru-c69260bfb25eea5a61be2e63efe3a46c.svg";